import {
    ChevronsLeft,
    ChevronLeft,
    ChevronRight,
    ChevronsRight,
} from "lucide-react";

export default function Pagination({
    currentPage = 1,
    totalPages = 1,
    totalData = 0,
    perPage = 10,

    onPageChange,
    onPerPageChange,
}) {

    const start =
        totalData === 0
            ? 0
            : (currentPage - 1) * perPage + 1;

    const end = Math.min(
        currentPage * perPage,
        totalData
    );

    return (
        <div className="mt-6 bg-white border border-slate-200 rounded-xl px-6 py-4">

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">

                {/* Left */}

                <div className="flex items-center gap-4">

                    <span className="text-sm text-gray-500">

                        Showing

                        <span className="font-semibold text-slate-700 mx-1">
                            {start}
                        </span>

                        -

                        <span className="font-semibold text-slate-700 mx-1">
                            {end}
                        </span>

                        of

                        <span className="font-semibold text-slate-700 mx-1">
                            {totalData}
                        </span>

                        records

                    </span>

                    <div className="flex items-center gap-2">

                        <span className="text-sm text-gray-500">
                            Rows
                        </span>

                        <select
                            value={perPage}
                            onChange={(e) =>
                                onPerPageChange?.(
                                    Number(e.target.value)
                                )
                            }
                            className="border rounded-lg px-3 py-1"
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>

                    </div>

                </div>

                {/* Right */}

                <div className="flex items-center gap-2">

                    <button
                        disabled={currentPage === 1}
                        onClick={() =>
                            onPageChange?.(1)
                        }
                        className="border rounded-lg p-2 hover:bg-gray-100 disabled:opacity-40"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    <button
                        disabled={currentPage === 1}
                        onClick={() =>
                            onPageChange?.(
                                currentPage - 1
                            )
                        }
                        className="border rounded-lg p-2 hover:bg-gray-100 disabled:opacity-40"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    <div className="px-4 py-2 border rounded-lg bg-slate-50">

                        Page

                        <span className="mx-2 font-semibold">

                            {currentPage}

                        </span>

                        /

                        <span className="mx-2">

                            {totalPages}

                        </span>

                    </div>

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() =>
                            onPageChange?.(
                                currentPage + 1
                            )
                        }
                        className="border rounded-lg p-2 hover:bg-gray-100 disabled:opacity-40"
                    >
                        <ChevronRight size={18} />
                    </button>

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() =>
                            onPageChange?.(
                                totalPages
                            )
                        }
                        className="border rounded-lg p-2 hover:bg-gray-100 disabled:opacity-40"
                    >
                        <ChevronsRight size={18} />
                    </button>

                </div>

            </div>

        </div>
    );
}